import React from 'react';
import { FileText, Users, Lightbulb, Calendar, GraduationCap, Briefcase, BookOpen, MessageCircle, ClockArrowDown, Eye, FolderCheck, Smile, CheckCircle, Zap, Scale, Gavel, Globe, Heart } from 'lucide-react';
const modules = [{
  icon: FileText,
  color: 'bg-blue-900',
  title: 'Clases listas',
  items: ['Paso a paso', 'Solo leer y explicar', 'Secuencia clara']
}, {
  icon: Users,
  color: 'bg-amber-500',
  title: 'Actividades',
  items: ['Para adolescentes', 'Generan debate', 'Participación real']
}, {
  icon: Lightbulb,
  color: 'bg-blue-700',
  title: 'Ejemplos reales',
  items: ['Casos argentinos', 'Actualidad jurídica', 'Conectan con la vida']
}, {
  icon: Calendar,
  color: 'bg-amber-600',
  title: 'Ciclo lectivo',
  items: ['Todo el año', 'Progresión lógica', 'Sin improvisar']
}, {
  icon: CheckCircle,
  color: 'bg-blue-900',
  title: 'Evaluaciones',
  items: ['Listas para usar', 'TP y grupales', 'Consignas claras']
}, {
  icon: BookOpen,
  color: 'bg-amber-500',
  title: 'Casos para debatir',
  items: ['Situaciones reales', 'Preguntas guía', 'Razonamiento jurídico']
}];
const topics = [{
  color: 'bg-blue-700',
  title: 'Derecho Constitucional',
  items: ['Constitución Nacional Argentina', 'Supremacía constitucional', 'Derechos y garantías', 'División de poderes', 'Control de constitucionalidad', 'Reforma constitucional', 'Ciudadanía y sistema republicano', 'Actividades de análisis constitucional']
}, {
  color: 'bg-red-500',
  title: 'Derecho Penal',
  items: ['Concepto de delito', 'Tipos penales', 'Responsabilidad penal', 'Garantías procesales', 'Sistema penal argentino', 'Casos prácticos', 'Análisis de situaciones reales', 'Debates guiados']
}, {
  color: 'bg-purple-600',
  title: 'Derecho Civil',
  items: ['Personas físicas y jurídicas', 'Capacidad', 'Contratos', 'Obligaciones', 'Responsabilidad civil', 'Derechos reales', 'Actividades prácticas']
}, {
  color: 'bg-orange-500',
  title: 'Derecho Laboral',
  items: ['Derechos del trabajador', 'Contrato de trabajo', 'Jornada laboral', 'Salario', 'Sindicatos', 'Conflictos laborales', 'Casos prácticos']
}, {
  color: 'bg-teal-600',
  title: 'Derechos Humanos',
  items: ['Declaración Universal', 'Sistema interamericano', 'Derechos civiles, sociales y políticos', 'Igualdad y no discriminación', 'Jurisprudencia aplicada', 'Análisis crítico']
}, {
  color: 'bg-indigo-600',
  title: 'Derecho Internacional',
  items: ['Organismos internacionales', 'Tratados', 'Derechos humanos en el mundo', 'Globalización y Derecho', 'Responsabilidad internacional']
}];
export function ProductSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-8 pb-20 bg-white" data-id="element-204">
      <div className="container mx-auto px-4" data-id="element-205">
        {/* Product Overview */}
        <div className="max-w-2xl mx-auto text-center" data-id="element-206">
          {/* Badge */}
          <div className="mb-6" data-id="element-207">
            <span className="inline-block px-5 py-2 bg-blue-900 text-amber-400 font-bold rounded-full text-sm uppercase tracking-wider" data-id="element-208">
              La Solución
            </span>
          </div>

          {/* Title */}
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4 tracking-tight" data-id="element-209">
            MEGA PACK <span className="text-blue-900" data-id="element-210">DERECHO 360™</span>
          </h2>

          {/* Subtitle */}
          <p className="text-lg text-slate-600 mb-10 max-w-xl mx-auto" data-id="element-211">
            Sistema completo de clases, actividades y evaluaciones{' '}
            <strong className="text-slate-800" data-id="element-212">ya probadas en aula</strong>.
          </p>

          {/* 4 Icon Badges Row */}
          <div className="grid grid-cols-4 gap-3 mb-10 max-w-md mx-auto" data-id="element-213">
            <div className="flex flex-col items-center gap-2" data-id="element-214">
              <div className="w-12 h-12 rounded-full bg-blue-50 border-2 border-blue-900 flex items-center justify-center" data-id="element-215">
                <CheckCircle className="h-5 w-5 text-blue-900" data-id="element-216" />
              </div>
              <span className="text-xs font-bold text-slate-700" data-id="element-217">Listo</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-218">
              <div className="w-12 h-12 rounded-full bg-blue-50 border-2 border-blue-900 flex items-center justify-center" data-id="element-219">
                <Users className="h-5 w-5 text-blue-900" data-id="element-220" />
              </div>
              <span className="text-xs font-bold text-slate-700" data-id="element-221">Probado</span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-222">
              <div className="w-12 h-12 rounded-full bg-blue-50 border-2 border-blue-900 flex items-center justify-center" data-id="element-223">
                <FolderCheck className="h-5 w-5 text-blue-900" data-id="element-224" />
              </div>
              <span className="text-xs font-bold text-slate-700" data-id="element-225">
                Organizado
              </span>
            </div>
            <div className="flex flex-col items-center gap-2" data-id="element-226">
              <div className="w-12 h-12 rounded-full bg-blue-50 border-2 border-blue-900 flex items-center justify-center" data-id="element-227">
                <Zap className="h-5 w-5 text-blue-900" data-id="element-228" />
              </div>
              <span className="text-xs font-bold text-slate-700" data-id="element-229">Usable</span>
            </div>
          </div>

          {/* ¿Qué Incluye? - Clean list style */}
          <div className="text-left max-w-sm mx-auto" data-id="element-230">
            <h3 className="text-xl font-bold text-slate-900 text-center mb-5" data-id="element-231">
              ¿Qué Incluye?
            </h3>
            <div className="bg-white border border-slate-200 rounded-2xl shadow-md overflow-hidden" data-id="element-232">
              {[{
              icon: FileText,
              label: 'Clases explicadas paso a paso'
            }, {
              icon: Users,
              label: 'Actividades pensadas para adolescentes'
            }, {
              icon: Lightbulb,
              label: 'Ejemplos reales y actuales'
            }, {
              icon: Calendar,
              label: 'Organización por ciclo lectivo'
            }, {
              icon: CheckCircle,
              label: 'Evaluaciones listas para usar'
            }, {
              icon: BookOpen,
              label: 'Casos reales para debatir en clase'
            }].map((item, i, arr) => {
              const Icon = item.icon;
              return <div key={i} className={`flex items-center gap-4 px-5 py-4 ${i < arr.length - 1 ? 'border-b border-slate-100' : ''}`} data-id="element-233">
                    <div className="w-9 h-9 rounded-full border-2 border-blue-900 flex items-center justify-center flex-shrink-0" data-id="element-234">
                      <Icon className="h-4 w-4 text-blue-900" data-id="element-235" />
                    </div>
                    <span className="text-slate-700 font-medium text-sm" data-id="element-236">
                      {item.label}
                    </span>
                  </div>;
            })}
            </div>
          </div>

          {/* Topics grid - horizontal scroll on mobile */}
          <div className="text-left max-w-2xl mx-auto mt-6" data-id="element-237">
            <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider text-center mb-3" data-id="element-238">
              Contenidos del ciclo lectivo
            </p>
            {/* Mobile: horizontal scroll. Desktop: grid */}
            <div className="flex gap-3 overflow-x-auto pb-3 md:grid md:grid-cols-3 md:overflow-visible snap-x snap-mandatory" data-id="element-239">
              {topics.map((topic, i) => <div key={i} className="bg-white border border-slate-200 rounded-xl p-4 shadow-sm flex-shrink-0 w-56 md:w-auto snap-start" data-id="element-240">
                  <div className={`${topic.color} w-9 h-9 rounded-lg flex items-center justify-center mb-3`} data-id="element-241">
                    <span className="text-white text-base" data-id="element-242">⚖️</span>
                  </div>
                  <h4 className="font-bold text-slate-900 text-sm mb-2" data-id="element-243">
                    {topic.title}
                  </h4>
                  <ul className="space-y-1" data-id="element-244">
                    {topic.items.map((item, j) => <li key={j} className="flex items-center gap-1.5 text-xs text-slate-600" data-id="element-245">
                        <CheckCircle className="h-3 w-3 text-amber-500 flex-shrink-0" data-id="element-246" />
                        {item}
                      </li>)}
                  </ul>
                </div>)}
            </div>

            {/* Bottom strip */}
            <div className="mt-4 bg-blue-50 border border-blue-100 rounded-xl px-5 py-3 flex flex-wrap justify-center gap-x-4 gap-y-1" data-id="element-247">
              <span className="text-xs font-semibold text-blue-900 w-full text-center mb-1" data-id="element-248">
                Cada clase incluye:
              </span>
              {['Desarrollo conceptual', 'Casos reales', 'Actividades listas', 'Consignas de debate', 'Material editable'].map((tag, i) => <span key={i} className="flex items-center gap-1 text-xs text-blue-800" data-id="element-249">
                  <CheckCircle className="h-3 w-3 text-amber-500" data-id="element-250" />
                  {tag}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}